import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Resets scroll to the top on forward navigation (PUSH/REPLACE) while preserving
 * the browser's restored position on back/forward (POP). Keyed on pathname only,
 * so in-page filter/search changes never yank the scroll position.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}
